import { Button, type ButtonType } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

type Props = {
    className?: string;
    type?: ButtonType;
    dataAutomation?: string;
    isDisabled?: boolean;
    onClick: VoidFunction;
};

const SaveAsNewSearchButton = ({ className, type = "flat", dataAutomation, isDisabled, onClick }: Props) => {
    return (
        <Button
            className={className}
            dataAutomation={dataAutomation}
            type={type}
            isDisabled={isDisabled}
            onClick={onClick}
        >
            {translate("si.lead_gen_filters.button.save_as_new")}
        </Button>
    );
};

export default SaveAsNewSearchButton;
